<template>
  <div class="help-window">
    <header class="h-70 w-wrap window-header">
      <i class="el-icon-close absolute fs-18 c-pointer" @click="closeBox" style="right:10px;top:6px"></i>
      <i class="el-icon-full-screen absolute fs-18 c-pointer" v-if="article" @click="fullScreenHelp" style="right:36px;top:6px;"></i>
      <div class="h-30 lh-30 ta-c fs-12">帮助文档</div>
      <div class="ta-c">
        <el-select
          style="width:380px"
          v-model="selectArticle"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键词"
          :remote-method="searchArticle"
          @change="selectOption">
            <el-option
              v-for="(item) in articleOptions" 
              :key="item.articleId"
              :label="item.articleTitle"
              :value="item.articleId">
            </el-option>
        </el-select>
      </div>
    </header>
    <div class="h-40 flex flex-center pd-lr15">
      <el-breadcrumb>
        <el-breadcrumb-item class="fs-12">
          <span @click="showAllMenu()" :class="`${breadList.length === 0 ? '' : 'breadText' }`">所有</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item class="fs-12" v-for="(item, index) in breadList" :key="index">
          <span @click="navHelp(breadList.length,index)" :class="`${(index + 1) === breadList.length ? '' : 'breadText' }`">{{item.name}}</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="pd-10" style="height:329px">
      <div v-if="article" class="rich-text" style="height:329px;overflow:auto" v-html="article"></div>
      <div v-if="groupItem" style="height:329px;overflow:auto">
        <el-collapse v-model="activeNames">
          <div
            @click="selectOption(article.articleId)"
            v-for="(article, index) in groupItem.articleList ? groupItem.articleList : 0" 
            :key="index"
            style="min-height:24px" 
            class="flex flex-center pd-tb5 fs-12 bd-b pd-lr15 c-pointer">
            {{article.articleTitle}}
          </div>
          <help-window-menu v-for="(item) in groupItem.children" @selectOption="selectOption" :key="item.code" :itemData="item"></help-window-menu>
        </el-collapse>
      </div>
    </div>
    <div class="h-40 shadow lh-40 pd-lr15">
      <span class="c-pointer text-select" style="color:#F13736" @click="navCenter">在帮助中心打开 <i class="el-icon-link"></i></span>
    </div>
    <el-dialog title="帮助文章" :visible.sync="dialogFullscreen" :fullscreen="true" :modal="false">
      <div v-html="article" class="rich-text"></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  Req_SearchArticle,
  Req_GetArticle,
  Req_GetVerticalList,
  Req_GetArticleList
} from '@/request/helpCenter'
import HelpWindowMenu from '@/components/Setting/HelpWindowMenu'
import {mapMutations,mapActions} from 'vuex'
export default {
  data() {
    return {
      activeNames:0,
      selectArticle:'',
      articleOptions:[],
      article:'',
      groupItem:null,
      articleMap:{},
      breadList:[],
      dialogFullscreen:false
    }
  },
  created() {
    // this.getVerticalList()
    const promise = Req_GetVerticalList({moduleCode:10,groupId:this.companyDetail.groupId})
    Promise.all([promise]).then(res => {
        res[0].forEach(item => {
          this.articleMap[item.code] = item
        });
        if(this.selectArticleId){
          this.loadArticle(this.selectArticleId)
        }
    }).catch(err => this.$catchErr(err))
  },
  methods: {
    ...mapActions(['setSerachArticle','clearSearchArticle','closeHelpBox','setActiveIndex']),
    fullScreenHelp(){
      this.dialogFullscreen = true
    },
    loadArticle(id){
      Req_GetArticle(id).then(res => {
        res.name = res.articleTitle
        this.article = res.articleContent
        this.breadList.push(res)
        this.handleBreadList(res.groupCode)
        const activeIndex = []
        this.breadList.forEach(item => {
          activeIndex.push(item.id)
          this.setActiveIndex(activeIndex.join('-'))
        });
      }).catch(err => this.$catchErr(err))
    },
    showAllMenu(){
      Req_GetArticleList({code:10,groupId:this.companyDetail.groupId}).then(res => {
        this.groupItem = null
        this.clearSearchArticle()
        this.article = ''
        this.breadList = []
        this.groupItem = res[0]
      }).catch(err => this.$catchErr(err))
    },
    navHelp(length,index){
      if((index+1) === length) return
      this.clearSearchArticle()
      this.groupItem = this.breadList[index]
      this.article = ''
      this.breadList.splice(index+1,length-1)
    },
    getVerticalList(){
      Req_GetVerticalList({
        moduleCode:10,
        groupId:this.companyDetail.groupId
      }).then(res => {
        res.forEach(item => {
          this.articleMap[item.code] = item
        });
      }).catch(err => this.$catchErr(err))
    },
    closeBox(){
      this.breadList = []
      this.groupItem = null
      this.article = ''
      this.closeHelpBox()
    },
    navCenter(){
      // const { href } = this.$router.resolve({
      //   path:`/helpCenter`,
      //   query:{
      //     articleId:this.selectArticleId
      //   }
      // })
      
      this.$router.push({
        path:`/helpCenter`,
        query:{
          articleId:this.selectArticleId
        }
      })
      this.closeHelpBox()
      // window.open(href,'_blank')      
    },
    selectOption(val){
      this.setSerachArticle(val)
      this.breadList = []
      this.groupItem = null
    },
    searchArticle(keyWord){
      Req_SearchArticle({
        keyWord,
        pageSize:9999,
        groupId:this.companyDetail.groupId
      }).then(res => {
        this.articleOptions = res
      }).catch(err => this.$catchErr(err))
    },
    handleBreadList(pCode){
      const articleMap = this.articleMap
      if(articleMap[pCode].pCode === 0){
        this.breadList.unshift(articleMap[pCode])
        return
      }else{
        this.breadList.unshift(articleMap[pCode])
        this.handleBreadList(articleMap[pCode].pCode)
      }
    }
  },
  computed:{
    selectArticleId(){
      return this.$store.state.HelpCenter.searchArticleId
    },
    companyDetail() {
      return this.$store.state.companyInfo
    }
  },
  watch: {
    selectArticleId(nV){
      if(!nV) return
      this.groupItem = null
      this.loadArticle(this.selectArticleId)
    }
  },
  components:{
    HelpWindowMenu
  }
}
</script>

<style lang="scss" scoped>
  .help-window{
    position: absolute;
    bottom: 10px;
    right: 20px;
    width: 400px;
    height: 500px;
    z-index: 999;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,.12), 0 0 3px 0 rgba(0,0,0,.04);
    .window-header{
      background: rgba(143, 143, 143, 0.1)
    }
    .breadText{
      cursor: pointer;
    }
    .breadText:hover{
      color: #F13736
    }
    .el-collapse-item >>> .el-collapse-item__content{
      padding-bottom: 0px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Setting/HelpWindow.vue